import React, { useState } from 'react';
import { Modal, Row, Col, Skeleton, Input, Form, Alert } from 'antd';

import PropTypes from 'prop-types';
import { get, has } from 'lodash';

import {
  convertNumberToRupiahCurrency,
  convertNumberToNumberRupiahCurrency,
} from 'utils';
import DisbursementService from 'services/disbursement';
import PdButton from 'components/pd-button';

import './style.scss';

function ModalReturn({
  orderDetail,
  visible,
  onOK,
  onCancel,
  onSubmitSuccess = () => {},
}) {
  const [form] = Form.useForm();
  const [error, setError] = useState({});

  function handleCustomerName() {
    const firstName = get(orderDetail, 'user.first_name', '');
    const lastName = get(orderDetail, 'user.last_name', '');
    return `${firstName} ${lastName}`;
  }

  async function handleSubmit(values) {
    try {
      const returnData = await DisbursementService.returnFund(
        get(orderDetail, 'id', ''),
        {
          return: {
            net_price: values.net_price.replace('.', ''),
          },
        }
      );
      onSubmitSuccess(returnData);
    } catch (e) {
      setError(e.response.data);
    }
  }

  const component = (
    <Row className="order-detail" type="flex" justify="center">
      <Col xs={0} lg={24} className="header">
        <h1 className="bold">Return Fund</h1>
      </Col>

      <Col xs={0} lg={24} className="body">
        <Row type="flex" justify="center">
          <Col lg={14} className="mb-16">
            {error.message && (
              <Alert
                message={error.message}
                type="error"
                showIcon
                closable
                onClose={() => {
                  setError(null);
                }}
              />
            )}
          </Col>
          <Col lg={15} className="mb-2">
            <Row>
              <Col lg={11} offset={1}>
                Total Payment
              </Col>
              <Col lg={12} className="bold">
                {convertNumberToRupiahCurrency(
                  get(orderDetail, 'total_price', 0)
                )}
              </Col>
            </Row>
            <Row>
              <Col lg={11} offset={1}>
                Invoice No
              </Col>
              <Col lg={12} className="bold">
                {get(orderDetail, 'invoice_number', '')}
              </Col>
            </Row>
            <Row>
              <Col lg={11} offset={1}>
                Customer Name
              </Col>
              <Col lg={12} className="bold">
                {handleCustomerName()}
              </Col>
            </Row>
          </Col>

          <Form
            form={form}
            layout="horizontal"
            onFinish={handleSubmit}
            initialValues={{
              net_price: convertNumberToNumberRupiahCurrency(
                get(orderDetail, 'total_price', 0)
              ),
            }}>
            <Col lg={15} className="mt-3">
              <div className="mb-1">
                <b>Confirm amount to be refund</b>
              </div>
              <Form.Item
                name="net_price"
                rules={[
                  {
                    required: true,
                    message: 'Input return fund',
                  },
                ]}>
                <Input
                  type="number"
                  addonBefore={'IDR'}
                  placeholder="Return Fund"
                />
              </Form.Item>
            </Col>
            <Col lg={20} className="text-center">
              <Form.Item>
                <PdButton
                  type="primary"
                  style={{ width: 164 }}
                  htmlType="submit">
                  Return Fund
                </PdButton>
              </Form.Item>
            </Col>
          </Form>
        </Row>
      </Col>
    </Row>
  );

  return (
    <>
      <Modal
        className="modal--orderDetail"
        open={visible}
        onOk={onOK}
        wrapClassName="hidden-wrap-modal"
        centered
        onCancel={onCancel}>
        {!has(orderDetail, 'id') ? (
          <div className="modal-container">
            <Skeleton active paragraph={{ rows: 8 }} />
          </div>
        ) : (
          <div className="modal-container">{component}</div>
        )}
      </Modal>
    </>
  );
}

ModalReturn.propTypes = {
  orderDetail: PropTypes.any,
  visible: PropTypes.any,
  onOK: PropTypes.any,
  onCancel: PropTypes.any,
  onSubmitSuccess: PropTypes.func,
};

export default ModalReturn;
